import { create } from "zustand";
import api from "../api/client";

export const useAuthStore = create((set, get) => ({
  token: localStorage.getItem("temto_token") || null,
  user: null,
  loading: false,
  error: null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const data = await api.login(email, password);
      const token = data.access_token;
      api.setToken(token);
      localStorage.setItem("temto_token", token);
      set({ token, loading: false });
      await get().fetchUser();
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  googleLogin: async (idToken) => {
    set({ loading: true, error: null });
    try {
      const data = await api.googleAuth(idToken);
      const token = data.access_token;
      api.setToken(token);
      localStorage.setItem("temto_token", token);
      set({ token, loading: false });
      await get().fetchUser();
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  register: async (email, password) => {
    set({ loading: true, error: null });
    try {
      await api.register(email, password);
      await get().login(email, password);
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchUser: async () => {
    try {
      const user = await api.getMe();
      set({ user });
    } catch {
      set({ user: null });
    }
  },

  logout: () => {
    api.setToken(null);
    localStorage.removeItem("temto_token");
    set({ token: null, user: null });
  },

  init: () => {
    const token = get().token;
    if (token) {
      api.setToken(token);
      get().fetchUser();
    }
  },
}));
